import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  user: {
    token: null,
    user_nicename: null,
  },
  isLoading: false,
  isError: false,
  loginError: null,
  registrationError: null,
};

export const login = createAsyncThunk(
  "auth/login",
  async ({ email, password }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(
        "https://app.reciteontv.com/?rest_route=/simple-jwt-login/v1/auth",
        { email: email, password: password, AUTH_KEY: "HZJAUTHRECITE" }
      );

      //const { token, user_nicename } = response.data;
      //const jwt = response.data.data.jwt;
      const token = response.data.data.jwt;
      //console.log(response.data);
      // Dispatch actions to update the state
      dispatch(setToken(token));
      //dispatch(setUserNicename(user_nicename));

      // Store the token and user_nicename in localStorage
      localStorage.setItem("token", token);
      //localStorage.setItem("user_nicename", user_nicename);

      //return { token, user_nicename };
      return { token };
    } catch (error) {
      // Check if the error is a 403 Forbidden response
      if (error.response && error.response.status === 403) {
        return rejectWithValue({ loginError: error.response.data.message });
      } else {
        return rejectWithValue({
          loginError: "An error occurred while logging in",
        });
      }
    }
  }
);

export const register = createAsyncThunk(
  "auth/register",
  async (user, { rejectWithValue }) => {
    if (!user || !user?.username || !user?.email || !user?.password) {
      return rejectWithValue({
        registrationError: "All fields are required for registration",
      });
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_ROOT}/register`,
        user
      );
      return res.data;
    } catch (error) {
      return rejectWithValue({
        registrationError: "An error occurred while registering",
      });
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setToken: (state, action) => {
      state.user.token = action.payload;
    },
    setUserNicename: (state, action) => {
      //state.user.user_nicename = action.payload;
    },
    logout: (state) => {
      state.user = {
        token: null,
        //user_nicename: null,
      };
      localStorage.removeItem("token");
      //localStorage.removeItem("user_nicename");
    },
    loginFailure: (state, action) => {
      state.loginError = action.payload;
    },
    resetAuthState: (state) => {
      state.isLoading = false;
      state.isError = false;
      state.loginError = null;
      state.registrationError = null;
    }
  },
  
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.isLoading = true;
        state.loginError = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.user.token = action.payload.token;
        //state.user.user_nicename = action.payload.user_nicename;
        state.isLoading = false;
        state.isError = false;
        state.loginError = null;
      })
      .addCase(login.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.loginError = action.payload.loginError || "Login failed";
      })
      .addCase(register.pending, (state) => {
        state.isLoading = true;
        state.registrationError = null;
      })
      .addCase(register.fulfilled, (state, action) => {
        state.user = {
          id: action.payload.id,
          username: action.payload.username,
          email: action.payload.email,
        };
        state.isLoading = false;
        state.isError = false;
        state.registrationError = null;
      })
      .addCase(register.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.registrationError =
          action.payload.registrationError || "Registration failed";
      })

  },
});

export const { setToken, logout,loginFailure,resetAuthState } = authSlice.actions;
//export const selectUsername = (state) => state.auth.user?.username;
//export const selectUserNicename = (state) => state.auth.user?.user_nicename;
export const selectLoginError = (state) => state.auth.loginError;
export const selectRegistrationError = (state) => state.auth.registrationError;
export default authSlice.reducer;
